import toast from "react-hot-toast";
import { ROLE, ROLES } from "./roles";
import { ROUTES } from "./routePaths";

export const redirectByRole = (role_id, navigate, {message}) => {
  let role = getRoleName(role_id);
  switch (role) {
    case ROLES.ADMIN: 
      navigate(ROUTES.DASHBOARD);
      toast.success(message);
      break;
    case ROLES.TRAINER:
      navigate(ROUTES.TRAINER_DASHBOARD);
      toast.success(message);
      break;
    case ROLES.MEMBER:
      // navigate(ROUTES.HOME);
      toast.error("Not Allowed in web");
      break;
    case ROLES.RECEPTIONIST:
      navigate(ROUTES.RECEPTIONIST_DASHBOARD);
      toast.success(message);
      break;
    default:
      navigate(ROUTES.LOGIN);
      break;
  }
};


function getRoleName(roleId) { 
  return ROLE[roleId] || "Unknown Role";
}